import { Fragment, type JSX, ReactNode } from "react";

import Avatar from "@mui/material/Avatar";
import {
  adjustAssetUrl,
  useConfigurationMeta,
} from "@plansoft-configuration-renderer/framework";

import { ButtonUiProps } from "./ButtonUiProps";

function ButtonUiImage(props: ButtonUiProps): JSX.Element {
  const { baseUrl } = useConfigurationMeta();
  const { imageSrc, imageHeight, imageWidth, imageVariant } = props;

  if (!imageSrc) {
    return <Fragment />;
  }

  const src = adjustAssetUrl(imageSrc, baseUrl);

  if (imageVariant != null) {
    return <Avatar src={src} variant={imageVariant} />;
  }

  return <img src={src} height={imageHeight} width={imageWidth} />;
}

export type UseButtonUiImageIcons = {
  startIcon: ReactNode | undefined;
  endIcon: ReactNode | undefined;
};

export function useButtonUiImageIcons(
  props: ButtonUiProps,
): UseButtonUiImageIcons {
  const { imagePosition } = props;

  const icon = <ButtonUiImage {...props} />;
  const startIcon = imagePosition == "start" ? icon : undefined;
  const endIcon = imagePosition == "end" ? icon : undefined;

  return { startIcon, endIcon };
}
